module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "in-page-nav d-none d-md-block"
  }, [_c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', [_c('a', {
      staticClass: "in-page-nav-link",
      class: [link.hash === _vm.active ? 'active' : ''],
      attrs: {
        "href": link.hash
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.scrollTo(link.hash)
        }
      }
    }, [_c('span', {
      staticClass: "in-page-nav-link-title"
    }, [_vm._v(_vm._s(link.title))]), _vm._v(" "), _c('span', {
      staticClass: "in-page-nav-link-dot"
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b06dfc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/InPageNav.vue
// module id = 631
// module chunks = 1